<template>
    <div class="bigdata_container" id="bigdata" v-loading="isLoading" element-loading-text="拼命加载中..."
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            {{ orgName }}数据大屏
        </div>
        <div class="time">{{ currentTime }}</div>
        <div class="quanp">
            <!-- <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
                onFullScreen ? "退出全屏" : "进入全屏"
            }}</el-button> -->
            <img src="../../../assets/img/homecare/screen.png" @click="showFullScreen" class='screen' />
        </div>
        <div class="serach_wrapper">
            <treeselect v-model="regionId" :options="deptOptions" :normalizer="normalizer" :appendToBody="true"
                z-index="9999" placeholder="请选择区域" @select="deptSelect" style="width: 140px; height: 26px" />
            <img src="../../../assets/img/homecare/search.png" @click="handleSearch('search')"
                style="position:absolute;cursor: pointer;width:20px;height:20px;margin-top:3px;margin-left:152px" />
        </div>

        <transition name="nameoftransition">
            <div class="info_tisp" v-show="infoTisp">
                <i class="el-message__icon el-icon-info"></i>未搜索到相关数据
            </div>
        </transition>
        <div class="bigdata_main" v-if="oldIndex === 0">
            <div id="container" style="width: 100%; height: 100%;margin-top:20px"></div>
            <div class="main_left">
                <div class="main_pane main_pane1">
                    <div class="titleHeader">
                        <div class="titleTxt">残疾类型</div>
                    </div>
                    <div class="typeBox">
                        <ul>
                            <li>
                                <div class="type">
                                    <span></span>类型
                                </div>
                                <div id="typeChart"></div>
                            </li>
                            <li>
                                <div class="type">
                                    <span></span>等级
                                </div>
                                <div id="degreeChart"></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 活动展示 -->
                <div class="main_pane main_pane2" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleTxt">活动展示</div>
                    </div>
                    <div class="acty">
                        <img :src="activityForm.activityUrl" class="img" />
                        <p>活动名称：{{ activityForm.activityName }}</p>
                        <p>活动时间：{{activityForm.finishTime  }}</p>
                        <p>活动内容：{{activityForm.activityContent  }}</p>
                    </div>
                </div>
            </div>
            <div class="main_center">
                <div class="map">
                    <ul class="datatype">
                        <li>
                            <div class="data">{{ totalForm.服务对象总数 }}</div>
                            <span>服务对象总数</span>
                        </li>
                        <!-- <li>
                            <div class="data">{{ totallist.serviceCustomerCount }}</div>
                            <span>活动数量</span>
                        </li> -->
                        <li>
                            <div class="data">{{ totalForm.以服务人数 }}</div>
                            <span>已服务人数</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="main_right">
                <!-- 残疾类型 -->
                <div class="main_pane main_pane4">
                    <div class="titleHeader">
                        <div class="titleTxt">残疾类型</div>
                    </div>
                    <ul class="disabledtype">
                        <li v-for="(v, i) in disList" :key='i' :class="[disIndex === i ? 'active' : '']" @click="disClick(i)">
                            {{ v.label }}</li>
                    </ul>
                    <div id="echartsThree" ref="echartsThree" style="height: 75%; width: 100%;"></div>
                </div>
                <!-- 服务工单类型 -->
                <div class="main_pane main_pane5" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleTxt">残疾人之家监控</div>
                    </div>
                    <!-- <div class="monitor">
                        <ul>
                            <li v-for="(v, i) in monitorList" :key="i" @click="monClick(i)"
                                :class="[monIndex === i ? 'active' : '', 'item']">{{
                                    v.name }}</li>
                        </ul>
                    </div> -->
                    <img src="../../../assets/img/homecare/nomontor.png" class='monimg'/>
                </div>
            </div>
        </div>
        <el-dialog :title="infotitle" :visible.sync="dialogVisible" width="30%" custom-class="speinfo"
            style='margin-top:28vh;' :before-close="handleClose">
            <div class="top">
                <div class="left">
                    <img :src="infoData.personPhoto" class='img' />
                    <div class="info">
                        <p v-if="typeValue == 2">站点名称：{{ infoData.statName }}</p>
                        <p v-else>姓名：{{ infoData.personName }}</p>
                        <p>联系方式：{{ infoData.personPhone }}</p>
                        <p class="add"><span class="first">地址：</span><span>{{ infoData.address }}</span></p>
                    </div>
                </div>
                <!-- <div class="right" @click="showVideo">视频通话</div> -->
            </div>
        </el-dialog>
        <!-- 弹窗 end -->
        <shipingtonghua v-if="videoModal" :userId="userinfo.id" :mobilePhone='userinfo.personPhone'
            :closeSP.sync="videoModal"></shipingtonghua>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import * as echarts from "echarts"
import shipingtonghua from "@/components/shipingtonghua.vue"
export default {
    name: "visualized",
    components: {
        shipingtonghua,
    },
    data() {
        return {
            currentTime: '',
            timeC: null,
            infoTisp: false,
            isLoading: false,
            keyword: "", //搜索
            onFullScreen: false, // 是否全屏
            echartThree: null, // 改造产品统计echarts
            map: null, //地图实例
            markers: [], //地图标记点
            dialogVisible: false,
            stepIndex: 1,
            dialogTitle: "",
            formData: {
                name: "",
                sex: "",
                age: "",
                idCode: "",
                phone: "",
                olderType: "",
            },
            nameList: [],
            typeList1: [], //托养类型
            degreeLits: [],
            comList: [],
            cid: '',
            orgList: [],
            stationData: [],
            userinfo: {},
            videoModal: false,
            infoData: {},
            typeValue: null,
            regionId: '',
            regionName: '',
            polygons: [],
            deptOptions: [],
            oldIndex: 0,
            infotitle: '',
            orgName: '',
            disList: [
                { label: '男女比例', value: 0 },
                { label: '婚姻状况', value: 1 },
            ],
            disIndex:0,
            typeIndex: 0,
            monitorList: [
                { name: '活动室' },
                { name: '棋牌室' },
                { name: '客厅' },
                { name: '学习室' }
            ],
            monIndex: 0,
            activityForm: {},
            totalForm:{},
            echartO:null,
            echartT:null,
            echartTh:null,
        }
    },
    async created() {
        this.orgName = this.$store.state.info.orgName
        this.regionId = this.$store.state.info.orgId
        this.cid = this.regionId
    },
    async mounted() {
        let self = this
        await self.loadMap()
        window.addEventListener("resize", () => {
            // 自适应所有echarts
            const handleResize = () => {
                if (!checkFull()) {
                    self.onFullScreen = false
                }
            }
            window.onresize = handleResize
            function checkFull() {
                let isFull =
                    document.fullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement
                if (isFull === undefined) isFull = false
                return isFull
            }
            self.$nextTick(() => {
                self.echartO && self.echartO.resize() // 
                self.echartT && self.echartT.resize() //
                self.echartTh && self.echartTh.resize() //
            })
        })
        this.init()
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    beforeDestroy() {
        // 组件销毁前清除定时器  
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    filters: {
    },
    _methods: {
        //获取组织
        listDept() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/getUserOrgTree",
                    method: "POST",
                    data: {
                    },
                })
                .then((res) => {
                    console.log(res, 'res')
                    if (res.code === 200) {
                        if (res.content != null) {
                            let arr = [res.content]
                            this.deptOptions = this.handleTree(arr, "deptId");
                        }
                    }
                })
        },
        /** 转换机构数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.orgId,
                label: node.label,
                children: node.children,
            };
        },
        deptSelect(item) {
            this.orgName = item.label
        },
        // 获取时间
        getTime() {
            let yy = new Date().getFullYear()
            let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1
            let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()
            let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds()
            this.currentTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
        },
        currentTime1() {
            setInterval(this.getTime, 500)
        },
        getcType(data1) {
            var chartDom = document.getElementById("typeChart")
            var myChart = echarts.init(chartDom)
            this.echartO=myChart
            var option
            option = {
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                        fontSize: 10 // 设置 tooltip 中文本的字体大小  
                    }
                },
                grid: {
                    //   top:'1%',
                    //   containLabel:true
                },
                legend: {
                    top: '54%',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 8
                    },
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 10,
                    orient: 'horizontal'
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['32%', '45%'],
                        center: ['45%', '27%'],
                        // adjust the start and end angle
                        itemStyle: {
                            normal: {
                                labelLine: {
                                    length: 5,
                                    length2: 5,
                                    show: true,
                                    color: '#8CFFF4'
                                }
                            }
                        },
                        label: {
                            normal: {
                                fontSize: 8,
                            }
                        },
                        color: [
                            "#5766EA", "#58B3FF", "#8CFFEF", "#D67DFF", "#FEDB65", "#70FF70", "#FF8A8A"
                        ],
                        data: this.getArray(data1)
                    }
                ]
            };
            option && this.echartO.setOption(option)
        },
        //中间统计数据
        getCenterList(){
            this.$http
                .request({
                    url: "/jjyl/admin/disabled/bigScreen/info/findCenterCountStat",
                    method: "POST",
                    data: {
                        id: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.totalForm = res.content
                        }
                    }
                })
        },
        //左边残疾类型
        getOneList() {
            this.$http
                .request({
                    url: "/jjyl/admin/disabled/bigScreen/info/findDisableType",
                    method: "POST",
                    data: {
                        id: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.typeList1 = res.content
                            this.getcType(this.typeList1)
                        }
                    }
                })
        },
        //残疾等级
        getDegrgeeList() {
            this.$http
                .request({
                    url: "/jjyl/admin/disabled/bigScreen/info/findDisableLevel",
                    method: "POST",
                    data: {
                        id: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.degreeLits = res.content
                            this.getcGegree()
                        }
                    }
                })
        },
         //等级
         getcGegree() {
            var chartDom = document.getElementById("degreeChart")
            var myChart = echarts.init(chartDom)
            this.echartT=myChart
            var option
            option = {
                backgroundColor: "transparent",
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                        fontSize: 10 // 设置 tooltip 中文本的字体大小  
                    }
                },
                grid: {
                    top: '5%',
                },
                legend: {
                    top: '54%',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 8
                    },
                    itemWidth: 12,
                    itemHeight: 12
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['32%', '45%'],
                        center: ['45%', '27%'],
                        itemStyle: {
                            normal: {
                                labelLine: {
                                    length: 5,
                                    length2: 5,
                                    show: true,
                                    color: '#8CFFF4'
                                }
                            }
                        },
                        label: {
                            normal: {
                                fontSize: 8,
                            }
                        },
                        color: [
                            "#5766EA", "#58B3FF", "#8CFFEF", "#D67DFF", "#FEDB65", "#70FF70", "#FF8A8A"
                        ],
                        data: this.getArray(this.degreeLits)
                    }
                ]
            };
            option && this.echartT.setOption(option)
        },
        echartsThree(nameList) {
            let arraylist = this.getArray(nameList)
            let nameD = []
            var istotal=0
            arraylist.forEach((item) => {
                nameD.push(item.name)
                istotal+=item.value
            })
           if(istotal===0){
            return false
           }
            var chartDom = document.getElementById("echartsThree")
            var myChart = echarts.init(chartDom)
            this.echartTh=myChart
            var option
            let value = '比例'
            var img = ''
            var trafficWay = arraylist
            var data = [];
            var color = ['#00ffff', '#00cfff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000']
            for (var i = 0; i < trafficWay.length; i++) {
                data.push({
                    value: trafficWay[i].value,
                    name: trafficWay[i].name,
                    itemStyle: {
                        normal: {
                            borderWidth: 5,
                            shadowBlur: 20,
                            borderColor: color[i],
                            shadowColor: color[i]
                        }
                    }
                }, {
                    value: 2,
                    name: '',
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            color: 'rgba(0, 0, 0, 0)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            borderWidth: 0
                        }
                    }
                });
            }
            var seriesOption = [{
                name: '',
                type: 'pie',
                clockWise: false,
                radius: ['30%', '35%'],
                center: ['48%', '45%'],
                hoverAnimation: false,
                itemStyle: {
                    normal: {
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#ddd',
                            formatter: function (params) {
                                var percent = 0;
                                var total = 0;
                                for (var i = 0; i < trafficWay.length; i++) {
                                    total += trafficWay[i].value;
                                }
                                if (total === 0) {
                                      return ''; // 当没有有效数据时，返回空
                                 }
                                if(params.value===0){
                                    percent=0 
                                }else{
                                    percent = ((params.value / total) * 100).toFixed(0);
                                }
                                if (params.name !== '') {
                                    return + percent + '%';
                                } else {
                                    return '';
                                }
                            },
                        },
                        labelLine: {
                            length: 10,
                            length2: 20,
                            show: true,
                            color: '#8CFFF4'
                        }
                    }
                },
                data: data
            }];
            option = {
                backgroundColor: 'transparent',
                color: color,
                title: {
                    text: '比例',
                    top: '40%',
                    textAlign: "center",
                    left: "46%",
                    textStyle: {
                        color: '#C9C9C9',
                        fontSize: 16,
                        fontWeight: '400'
                    }
                },
                grid: {
                    top: '3%',
                    bottom: '3%'
                },
                graphic: {
                    elements: [{
                        type: "image",
                        z: 3,
                        style: {
                            image: img,
                            width: 178,
                            height: 178
                        },
                        left: 'center',
                        top: 'center',
                        position: [100, 100]
                    }]
                },
                tooltip: {
                    show: false
                },
                legend: {
                    orient: 'horizontal',
                    // x: 'left',
                    data: nameD,
                    bottom: '5%',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 10
                    },
                    itemWidth: 14,
                    itemHeight: 14
                },
                toolbox: {
                    show: false
                },
                series: seriesOption
            }
            option && this.echartTh.setOption(option)
        },
        // 活动展示
        getTwoList() {
            this.$http
                .request({
                    url: "/jjyl/admin/buActivity/info/findList",
                    method: "POST",
                    data: {
                        orgId: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.activityForm = res.content[0]
                        }
                    }
                })
        },
         //右边边类型切换
         disClick(i) {
            this.disIndex = i
            this.comList = []
            if (i === 0) {
                this.getSexList()
            } else if (i === 1) {
                this.gethyList()
            } 
        },
        //右边残疾类型 -年龄分布
        gethyList() {
            this.$http
                .request({
                    url: "/jjyl/admin/disabled/bigScreen/info/findAgeDistribution",
                    method: "POST",
                    data: {
                        orgId: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.echartsThree(res.content)
                        }
                    }
                })
        },
        //右边残疾类型男女比例
        getSexList() {
            this.$http
                .request({
                    url: "/jjyl/admin/disabled/bigScreen/info/findGenderPercent",
                    method: "POST",
                    data: {
                        orgId: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.echartsThree(res.content)
                        }
                    }
                })
        },
        //残疾人监控
        getSpeList() {

        },
        monClick(i) {
            this.monIndex = i
        },
        getArray(disabilityData) {
            const data = [];
            // 遍历对象并收集数据  
            for (const key in disabilityData) {
                if (disabilityData.hasOwnProperty(key)) {
                    data.push({
                        name: key,
                        value: disabilityData[key]
                    });
                }
            }
            return data
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        formatDate(dateStr) {
            // 将日期字符串从 'YYYY-MM-DD' 格式转换为 'MM.DD' 格式  
            const [year, month, day] = dateStr.split('-').map(Number);
            return `${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
        },

        handleClose() {
            this.dialogVisible = false
        },
        showVideo() {
            this.userinfo = this.infoData
            this.videoModal = true
        },
        //获取服务站打点
        getStation() {
            this.$http
                .request({
                    url: "/ypt/admin/serviceStation/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 10000,
                         dataId: this.cid,
                        type: 697
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.stationData = res.content.list || []
                            let data = this.stationData.filter(
                                (item) => item.addressLng && item.addressLat
                            )
                            data.forEach((item) => {
                                item.longitude = item.addressLng
                                item.latitude = item.addressLat
                            })
                            this.renderMapMarker(data, 2)
                        }
                    }
                })
        },
        handleSearch(sign = "", id = "") {
            let self = this
            self.map.remove(this.markers)
            self.markers = []
            self.cid = self.regionId
            self.loadMap()
            self.getCenterList()
            self.getOneList()  //托养
            self.getDegrgeeList(),
            self.getTwoList()  //本周课程
            self.getSexList()
            self.getSpeList()
            //定位打点
            // this.getService()
            // this.getStation()
            // this.getCustome()
        },
        renderMapMarker(data, value) {
            var image = null
            image = require("@/assets/img/map/serviceStation.png")
            let self = this
            var endIcon = new AMap.Icon({
                size: new AMap.Size(40, 47),
                image: image,
                imageSize: new AMap.Size(32, 36),
            })
            data.forEach((item) => {
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: endIcon,
                })

                self.markers.push(marker)
                marker.on("mouseover", (e) => {
                    marker.setTitle(item.name)
                })
                marker.on("click", (e) => {
                    self.dialogVisible = true
                    this.typeValue = value
                    console.log(value,'v')
                    if (value === 1) {
                        self.infotitle = '服务人员基本信息'
                    } else if (value === 2) {
                        this.infoData = item //
                        this.infotitle = '服务站点基本信息'
                        this.infoData.personPhone = item.phone
                        this.infoData.personPhoto = item.photo
                    }
                })
            })
            self.map.add(self.markers)
            // self.map.add(self.polygon)
            self.map.setFitView(self.polygon) //视口自适应
        },
        //循环遍历地址
        async loopAddress() { },
        async init() {
            await Promise.all([
                this.listDept(),
                this.currentTime1(),
                this.getCenterList(),
                this.getOneList(),
                this.getDegrgeeList(),
                this.getTwoList(),
                this.getSexList(),
                this.getSpeList(),
            ]);
            this.$nextTick(() => {
                setTimeout(async () => {
                    //太慢了 先去掉
                    await this.getStation()
                }, 550)
            })
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.map = new AMap.Map("container", {
                        resizeEnable: true,
                        _mapStyle: "amap://styles/darkblue",
                        get mapStyle() {
                            return this._mapStyle
                        },
                        set mapStyle(value) {
                            this._mapStyle = value
                        },
                        zoom: 8,
                    })
                    this.areaBG(this.map, this.orgName)
                    this.map.setZoom(8)
                    // this.map.setCenter([119.015372,33.61037])
                    resolve()
                }, 300)
            })
        },
        areaBG(map, cityName) {
            let vm = this
            if (vm.polygons && vm.polygons.length > 0) {
                vm.polygons.forEach(polygon => {
                    vm.map.remove(polygon); // 从地图上移除多边形
                });
                vm.polygons = []; // 清空存储多边形的数组
            }
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                console.log(cityName, 'cityName')
                district.search(`${cityName}`, function (status, result) {
                    console.log(result, 'result')
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            vm.polygons.push(polygon)
                            console.log(polygon)
                        }
                    }
                })
            })
        },
        //获取地址
        getDistrict(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 3,
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0].districtList)
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
    beforeDestory() {
        window.removeEventListener("resize")
    },
}
</script>
<style>
html,
body {
    overflow: hidden;
}

</style>
<style lang="less" scoped>
html{
    font-size:20px;
}
/deep/.vue-treeselect__control {
    background: transparent !important;
    border: 1px solid #57EAE7 !important;
}

/deep/.vue-treeselect__single-value,
/deep/.vue-treeselect__placeholder {
    color: #fff !important;
    font-size: 13px;
    line-height: 26px !important
}

/deep/.vue-treeselect__control {
    height: 26px !important;
}

/deep/.vue-treeselect__menu {
    display: block !important;
    z-index: 9999;
}

/deep/.el-carousel {
    width: 100%;
    height: 100%;
}

.small {
    color: #fff;
    font-size: 16px;
    text-align: center;
    padding-top: 15px;
}
/deep/.el-dialog__headerbtn {
                top: 13px;
            }
/deep/.speinfo {
    background: #2D497D;
    border: 1px solid #91CDFF;

    .el-dialog__header {
        padding: 5px 6px;
        margin: 8px 9px;
        background: #6181BC;
        border: 1px solid #91CDFF;

        .el-dialog__title,
        .el-dialog__close {
            font-size: 13px;
            color: #fff;

            /deep/.el-dialog__headerbtn {
                top: 10px;
                right:10px;
            }
        }
    }

    .img {
        width: 42px;
        height: 42px;
        min-width: 42px;
        border-radius: 4px;
        margin-right: 10px;
    }

    .top {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;
        }

        .right {
            width: 132px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #91CDFF;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
            color: #fff;
            font-size: 12px;
        }

        .add {
            display: flex;

            .first {
                white-space: nowrap;
            }
        }
    }

    .el-dialog__body {
        padding: 11px 16px;
    }
}
#typeChart,
#degreeChart {
    width: 90%;
    height: 32vh;
}
.nameoftransition-enter-active,
.nameoftransition-leave-active {
    transition: opacity 0.5s;
}

.nameoftransition-enter,
.nameoftransition-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}


.bigdata_container {
    * {
        box-sizing: content-box;
    }
}

/deep/ .el-carousel__container {
    height: 100% !important;

    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
        color: #489aff;
        font-weight: bold;
        font-size: 22px;
    }
}


/deep/ .serach_wrapper {
    z-index: 100;
    position: absolute;
    right: 5%;
    top: 30px;
    transform: translateX(-50%);
    display: flex;

    .el-button {
        color: #0291c2;
        background: #041d4d;
        border: none;
    }

    .el-button--small {
        padding: 5px 6px;
    }

    .el-input__inner {
        color: #0291c2;
        background: #102132;
        border-color: #233b87;
    }
}

.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../../../assets/img/homecare/bg.png") no-repeat center center;
    background-size: 100% 100%;

    .info_tisp {
        min-width: 380px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: #ebeef5;
        position: fixed;
        left: 50%;
        top: 20px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        background-color: #edf2fc;
        border-radius: 5px;
        -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s,
            -webkit-transform 0.4s;
        padding: 15px;
        display: flex;
        align-items: center;
        line-height: 1;

        .el-message__icon {
            margin-right: 10px;
        }
    }

    .header {
        margin: auto;
        width: 100%;
        height: 77px;
        background: url("../../../assets/img/homecare/topbg.png") no-repeat center center;
        background-size: 100%;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 30px;
    }

    .bigdata_main {
        position: absolute;
        left: 0;
        top: 50px;
        right: 0;
        bottom: 0;

        .main_pane {
            /* // background: linear-gradient( 180deg, rgba(35,58,100,0) 0%, #233A64 100%); */
            background: #1B3054;
            height: 44vh;
            position: relative;
            z-index: 999;
        }

        .main_left {
            position: absolute;
            top: 4%;
            bottom: 0%;
            left: 10px;
            width: 20%;
            overflow-y: auto;

            .main_pane1 {
                .titleBox {
                    height: 170px;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 0 !important;
                        height: 0 !important;
                    }
                }
            }

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .main_center {
            position: absolute;
            top: 4%;
            right: 22.5%;
            left: 22.5%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .main_right {
            position: absolute;
            top: 4%;
            bottom: 0%;
            right: 10px;
            width: 20%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .titleHeader {
            background: url("../../../assets/img/homecare/part.png") no-repeat;
            background-size: 100%;
            height: 6vh;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .tititleTxttleIcon {
                display: inline-block;
                height: 5.4vh;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size:18px;
                line-height: 4.1vh;
                color: #fff;
                margin-left: 10%;
            }
        }

        .iconimg {
            /* // background: url("../assets/img/title-icon.png") no-repeat center
            //     center; */
            background-size: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .titleIcon {
                display: inline-block;
                height: 37px;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 16px;
                line-height: 37px;
                color: #569cea;
            }
        }

        .titleBox {
            width: 100%;
            padding: 0 12px;
            box-sizing: border-box;
            border: 1px solid #1b3074;

            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                li {
                    margin-top: 20px;
                    width: 25%;
                    color: #ffffff;
                    text-align: center;
                    line-height: 1;

                    .bgimg {
                        font-family: Unidtrsmled;
                        font-size: 16px;
                        background-size: 100%;
                        display: inline-block;
                        border-radius: 5px;
                        color: #02e0e4;
                        width: 70%;
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 5px;
                        cursor: pointer;
                    }

                    p {
                        font-family: "Unidtrsmled";
                        margin-top: 6px;
                        font-size: 12px;
                    }
                }
            }

            .li {
                padding-left: 4px;
                font-size: 14px;
                display: flex;
                margin-top: 10px;
                flex-direction: row;
                color: #fff;
                line-height: 24px;

                .img {
                    border-radius: 50%;
                    height: 24px;
                    width: 26px;
                    background: #489aff;
                    text-align: center;
                    font-size: 14px;
                    font-family: Unidtrsmled;
                }

                .txt {
                    margin-left: 20px;
                    width: 52%;
                    overflow: hidden;
                    height: 18px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: center;
                }

                .time {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        .flex1 {
            display: flex;
            flex-direction: column;
        }


        .map {
            position: relative;
            margin-top: 30px;
            text-align: center;
            color: #4ac3ff;
            padding: 0 24px;

            .title_wrap {
                position: absolute;
                top: -0%;
                left: 50%;
                font-weight: bold;
                transform: translateX(-50%);
            }

            &:nth-child(1) {
                position: relative;
                top: -10px;
                position: relative;
                padding: 30px 3px 5px;
                box-sizing: border-box;
                overflow: hidden;

                .map_wrapper {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background-size: 100% 100%;
                }
            }

            &:nth-child(1) {
                margin-top: 4px;
            }
        }
    }

    .time {
        font-size: 14px;
        color: #fff;
        top: 37px;
        position: absolute;
        left: 20px;
    }

    .quanp {
        width: 20px;
        height: 20px;
        float: right;
        position: absolute;
        top: 31px;
        right: 28px;
        z-index: 999;

        .screen {
            width: 100%;
            height: 100%
        }
    }
}

.datatype {
    display: flex;

    li {
        margin-right: 24px;

        .data {
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            color: #fff;
            padding: 0 20px;
            min-width: 80px;
            margin-bottom: 6px;
            font-weight: bold;
            background: linear-gradient(90deg, rgba(55, 103, 236, 0) 0%, #7AC2FF 78%, rgba(122, 194, 255, 0) 100%)
        }

        .unit {
            font-size: 12px;
        }

        span {
            color: #fff;
            font-size: 14px;
        }
    }
}

.disabledtype {
    display: flex;
    justify-content: space-between;
    margin:1.2vh 25px 0;

    li {
        font-size: 14px;
        color: #C9C9C9;
        height: 5vh;
        line-height: 5vh;
        padding: 0 12px;
    }

    .active {
        background: linear-gradient(180deg, rgba(55, 103, 236, 0) 0%, #7AC2FF 78%, rgba(122, 194, 255, 0) 100%);
        opacity: 0.78;
        color: #8CFFF6;
        text-align: center;
    }
}

/* // 弹框步骤条样式 */
/deep/ #el-step {
    margin-bottom: 30px;

    .el-step__icon.is-text {
        border-radius: 5px;
    }

    .is-finish .el-step__icon {
        background: #409eff;
    }

    .el-step__icon {
        width: auto;
        padding: 22px 38px;
        color: #ffffff;
        cursor: pointer;
        border: none;
        background: #c0c4cc;
    }

    .el-step {
        height: 40px;
        margin-bottom: 24px;
    }

    .el-step.is-horizontal .el-step__line {
        top: 20px;
    }
}

.check_form_item {
    img {
        width: 100px;
        height: 100px;
    }
}

.el-step.is-center /deep/.el-step__line {
    right: -27%;
    left: 73%;
    border-top: 1px solid #c8b226;
    background-color: transparent;
}

/deep/ .check_form_item,
/deep/ .acceptance_form_item {
    display: flex;
    flex-direction: column;

    .el-form-item__label {
        width: 100% !important;
        margin-bottom: 12px;
        text-align: left;
        border-bottom: 1px solid #c0c4cc;
    }

    /deep/ .el-form-item__content {
        margin-left: 0 !important;
    }
}

.photo {
    font-size: 0;

    img {
        width: 160px;
        height: 160px;
    }
}

/deep/.el-dialog {
    background: #092267;
    opacity: 0.8;
}

#el-step /deep/.el-step__icon {
    background: none;
    color: #c8b226;
    border: 1px solid #c8b226;
}

#el-step /deep/.is-finish .el-step__icon {
    background: #c8b226;
    color: #fff;
}

/deep/.dialog_container .el-dialog__footer {
    background: #092267;
    border-top: none;
    opacity: 0.8;
    text-align: center;

    .el-button {
        border: 1px solid #4a93dc;
        color: #fff;
        margin-bottom: 8px;
        background: #092267;
    }

    .el-button:hover {
        background: #092267;
    }
}

/deep/.el-form-item__label {
    color: #fff;
}

.el-input.is-disabled /deep/.el-input__inner {
    background-color: #85b6db;
    color: #fff;
    opacity: 0.55;
    border: none;
}

.el-textarea.is-disabled /deep/.el-textarea__inner {
    background-color: #85b6db;
    color: #fff;
    border: none;
    opacity: 0.55;
}

/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

/deep/.el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

.acty {
    margin:1.2vh 26px 0;
    .img {
        width: 100%;
        height: 22vh;
    }

    p {
        font-size: 14px;
        color: #91CDFF;
        margin-top: 1.5vh;
    }
}

.monimg {
    margin:2vh 23px 1vh;
    height:34vh;
    width:86%;
}
.typeBox {
    margin:1.5vh 2% 0;
            ul {
                display: flex;
                justify-content: space-between;

                li {
                    width: 202px;

                    .type {
                        width: 100%;
                        background: linear-gradient(270deg, rgba(31, 76, 162, 0) 0%, #1F4CA2 100%);
                        color: #fff;
                        font-size: 10px;

                        line-height: 30px;
                        text-indent: 12px;
                    }

                    span {
                        display: inline-block;
                        width: 7px;
                        height: 7px;
                        background: #fff;
                        border-radius: 50%;
                        margin-right: 8px;
                    }
                }
            }
        }

</style>
